import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/History.css";
import historyImg from "../img/his.jpg"; // optional image (place one in src/img)

const History = () => {
  return (
    <section className="history-section py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* ===== Left Column (Text) ===== */}
          <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
            <h2 className="fw-bold mb-4 text-primary">Our History</h2>
            <p className="lead text-muted mb-3">
              <strong>Auxilium Technical Training Centre</strong> was started in
              <strong> 1973</strong> and inaugurated by
              <strong> Rev. Fr. Joseph Amaladoss</strong> as a non-formal
              institute.
            </p>
            <p className="text-muted mb-3">
              In the course of time, in <strong>1975</strong>, the{" "}
              <strong>Welding trade</strong> was affiliated to the{" "}
              <strong>State Government</strong>.
            </p>
            <p className="text-muted">
              In subsequent years, the <strong>Wireman</strong> and{" "}
              <strong>Electrician</strong> trades were affiliated to{" "}
              <strong>NCVT</strong> (National Council for Vocational Training),
              marking the institute’s commitment to quality technical education.
            </p>
          </div>

          {/* ===== Right Column (Image) ===== */}
          <div className="col-lg-6 col-md-12 text-center">
            <img
              src={historyImg}
              alt="Auxilium Training Centre"
              className="img-fluid rounded shadow-lg history-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default History;
